import { ITag, IVariance } from '@/interfaces';

export default class Product {
  public productid: string;
  public name: string;
  public description: string;
  public ismij: boolean;
  public isonfb: boolean;
  public isonig: boolean;
  public isonweb: boolean;
  public isusj: boolean;
  public privatenotes: string;
  public s3keyproduct: string;
  public s3keythumbnail: string;
  public tags: ITag[];
  public variances: IVariance[];

  constructor() {
    this.productid = '';
    this.name = '';
    this.description = '';
    this.ismij = false;
    this.isonfb = false;
    this.isonig = false;
    this.isonweb = false;
    this.isusj = false;
    this.privatenotes = '';
    this.s3keyproduct = '';
    this.s3keythumbnail = '';
    this.tags = [];
    this.variances = [];
  }
}


